import { BenchmarkingItem, BenchmarkingReportSettings } from '@/hooks'

export const getProcessedData = (
    data: BenchmarkingItem[],
    reportSettings: BenchmarkingReportSettings,
    labels: {
        currentYear: string
        baselineYear: string
        previousYear: string
    }
): Array<Record<string, unknown>> => {
    const { basis, analysisType, comparisonPeriod } = reportSettings

    // For 'trend' analysis type
    if (analysisType === 'trend') {
        const trendMap = new Map<string, Record<string, unknown>>()

        for (const item of data) {
            const { billDate, entityId } = item
            const current = item[basis]?.current

            if (!billDate) {
                continue
            }

            // If the date doesn't exist in the map, create a new entry
            if (!trendMap.has(billDate)) {
                trendMap.set(billDate, {
                    date: billDate,
                    [entityId]: current,
                })
            } else {
                // Add or update the entity's current value for that date
                const existingEntry = trendMap.get(billDate)
                if (existingEntry) {
                    existingEntry[entityId] = current
                }
            }
        }

        return Array.from(trendMap.values())
    }

    // For 'average' and 'totals' analysis types
    const summaryMap = new Map<string, Record<string, unknown>>()

    for (const item of data) {
        const entityId = item.entityId.toString()

        // Avoid duplicates by checking if the entity is already processed
        if (!summaryMap.has(entityId)) {
            const entity: Record<string, unknown> = {
                entityId,
                [labels.currentYear]: item[basis]?.current,
            }

            if (comparisonPeriod === 'baselineYear') {
                entity[labels.baselineYear] = item[basis]?.baseYear
            } else {
                entity[labels.previousYear] = item[basis]?.previousYear
            }

            summaryMap.set(entityId, entity)
        }
    }

    return Array.from(summaryMap.values())
}
